export default {
  messages: {
    required: "Ce champ est obligatoire",
    numeric: "Le champ ne peut contenir que des chiffres",
    email: "Le champ doit contenir un email valide",
  },
};
